import React from 'react'

export function ModalTitle({
  children,
}: {
  readonly children: React.ReactNode
}) {
  return (
    <h2 className={'text-headline-1 text-center font-demibold mb-2.5'}>
      {children}
    </h2>
  )
}
